import React from 'react';
import './login.css';
import LoginForm from './LoginForm';
import {useTheme} from '../../../Context/ThemeContext';
import darkModeIcon from './../../../assets/images/dark-mode-icon.svg';
import lightModeIcon from './../../../assets/images/light-mode-icon.svg';


const SignIn: React.FC = () => {
  const { toggleTheme } = useTheme();


  return (
    <div className='page-container-alt'>
        <LoginForm type={1}/>
    </div>
  );
};

export default SignIn;
